export const POST_LOGIN_BIND_MOBILE_SUCCESS = 'POST_LOGIN_BIND_MOBILE_SUCCESS';
export const LOADING_MESSAGE = '请稍等...';
